// Created by Michael Abadi Santoso
// 25 May 2020
// Copyright OKKAMI

///
/// Use this class for generating component globally that needed for the index.js
///
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`


  *,
  *::after,
  *::before {
    margin: 0px;
    padding: 0px;
    box-sizing: inherit;
  }

  html {
    font-size: 62.5%;
  }

  body {
    box-sizing: border-box;
    font-family: 'Open Sans', 'Montserrat', sans-serif;
  }

  list {
    margin: 20px 50px;
  }

  listRow {
    display: flex;
    line-height: 24px;
    white-space: nowrap;
    margin: 10px 0;
    padding: 10px;
    background: #ffffff;
    border-bottom: 1px solid #e3e3e3;
  }
  
  .date-selector p {
    font-family: inherit !important;
    color: currentColor;
    font-size: 14px;
  }
`;

export default GlobalStyles;
